/* eslint-disable no-use-before-define */
import React from 'react'
import { showModal, arrayFrom, icons, showBondOrder, format, isEmpty, isNumeric } from '../../twd'

export const formatStatus = ({tradeNum:orderNo, shown, setShown, rec}) => {

    let rs = arrayFrom(rec.tradeExecStatus)
        .filter(Boolean)

    if (rs.length<1) {
        return <tr style={{display:'none'}}></tr>
    }

    const isShown = shown[orderNo]
    if (!isShown ) {
        rs = rs.slice(0,1)
    }


    return <tr>
        <td className="text-center" style={{verticalAlign:"top"}}>
            { formatExpandButton({rec, orderNo, shown, setShown}) }
        </td>
        <td colSpan={13} style={{verticalAlign:"top"}}>
            { rs.map((r, i) => {
                return <div key={i}>
                    { formatStatusActionButton({
                        ...rec,
                        action: r.action,
                        qty: r.qty || rec.tradeQtyBond,
                        orderNo: orderNo,
                        quoteId: r.quoteId,
                        yld: r.yield,
                        price: r.price,
                    }) }
                    { formatStatusNotes(r) }
                    </div>
            }) }
        </td>
    </tr>
}

const formatStatusActionButton = ({holdCusip, acctNo, action, price, qty, yld, orderNo, quoteId }) => {
    const isNote = String(action).toLowerCase().indexOf('accept')===0

    switch(action) {
        case 'accept':
        case 'accept-buy':
        case 'accept-sell':
            return <React.Fragment><button
                data-name="orders-blotter-action-button"
                className="btn btn-sm btn-primary"
                style={{width:'65px'}}
                onClick={(e) => showModal({
                    view: 'order-detail',
                    action,
                    orderNo,
                    isNote,
                    source: e.target,
                })}
            >Accept</button><Sep/></React.Fragment>

        case 'buy':
        case 'limitbuy':
            return <React.Fragment><button
                data-name="orders-blotter-action-button"
                className="btn btn-sm btn-primary"
                style={{width:'65px'}}
                onClick={() => showBondOrder({
                    action: 'B',
                    cusip: holdCusip[0],
                    acctNo: acctNo[0],
                    from: 'orders',
                    qty,
                    price,
                    yld,
                    executionType: action==='limitbuy' ? 'Limit' : 'Firm',
                    sourceAction: 'Z',
                    sourceOrderNo: `${orderNo}|${quoteId || ''}`,
                })}
            >Buy</button><Sep/></React.Fragment>

        case 'sell':
        case 'limitsell':
            return <React.Fragment><button
                data-name="orders-blotter-action-button"
                className="btn btn-sm btn-primary"
                style={{width:'65px'}}
                onClick={() => showBondOrder({
                    action: 'S',
                    cusip: holdCusip[0],
                    acctNo: acctNo[0],
                    from: 'orders',
                    qty,
                    price,
                    yld,
                    executionType: action==='limitsell' ? 'Limit' : 'Firm',
                    sourceAction: 'Y',
                    sourceOrderNo: `${orderNo}|${quoteId || ''}`,
                })}
            >Sell</button><Sep/></React.Fragment>

        default:
            return <React.Fragment><span aria-hidden={true} style={{padding:'0 0 0 70px'}}></span></React.Fragment>
    }
}

const formatExpandButton = ({orderNo, shown, setShown, rec}) => {

    if (arrayFrom(rec.tradeExecStatus).length < 2) {
        return null
    }

    const isShown = shown[orderNo]
    return <button
        data-name="orders-blotter-expand-button"
        className="btn-link"
        data-order-no={orderNo}
        onClick={() => {
            setShown({...shown, [orderNo]: !!!isShown})
        }}
        >{isShown ? icons.minus : icons.plus}</button>
}

const Sep = () => <span aria-hidden={true} style={{padding:'0 0 0 5px'}}></span>

const formatStatusNotes = ({execId, status, text, time, price, yield:yield_, bestOf, passes, commission}) => {

    switch(status) {
    case 'Bid':
    case 'Offer':
    case 'Executed':
        return <React.Fragment>
            <span data-exec-id={execId}>
            <b>{status}</b>: {time}
            { isNumeric(price) && <React.Fragment><Sep /><b>Price</b>: {format.price3N(price)}</React.Fragment> }
            { isNumeric(yield_) && <React.Fragment><Sep /><b>Yield</b>: {format.ytw3(yield_)}</React.Fragment> }
            { !isEmpty(commission) && <React.Fragment><Sep />{formatText(commission)}</React.Fragment>}
            { !isEmpty(text) && <React.Fragment><Sep />{formatText(updateExpireText(text))}</React.Fragment>}
            { isNumeric(bestOf) && isNumeric(passes) && <React.Fragment>{` (Best of ${bestOf}, ${passes} Passes)`}</React.Fragment>}
            </span>
        </React.Fragment>
    case null:
        return <React.Fragment>
            <span data-exec-id={execId}>
            {formatText(text)}
            </span>
        </React.Fragment>
    default:
        return <React.Fragment>
            <span data-exec-id={execId}>
            <b>{status}</b>: {time}
            {text && <React.Fragment><Sep /><b>Text</b>: {formatText(text)}</React.Fragment>}
            </span>
        </React.Fragment>
    }
}

const updateExpireText = (text) => (text || '').replace('Expires', '<b>Expires:</b>').replace('Expired', '<b>Expired:</b>')

const formatText = (html) => <span dangerouslySetInnerHTML={{__html:html}} />


// WEBPACK FOOTER //
// ./src/orders/blotter/format-status.js